import { render, staticRenderFns } from "./TransactionOrderList.vue?vue&type=template&id=23ab2719&"
import script from "./TransactionOrderList.vue?vue&type=script&lang=js&"
export * from "./TransactionOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports